/**
 * 共通体験カード上のテーマタグ表示で除外する `tagGroupName` の一覧。
 *
 * JCAT-4853 「トップページ：テーマタグの調整」との連動仕様。
 * 値の更新は本ファイルのみを変更すれば全カードに反映される。
 *
 * リテラルの出典: `wabunka_tag_groups.name` の実値。
 * 確認ソース: `openspec/changes/adjust-top-theme-tags/design/calchez-script.md`
 * （`Trending Now` / `Seasonal Highlights` ともに `created_at DESC` 並び順の現行 8 件に含まれる）。
 */
export const EXCLUDED_THEME_TAG_GROUP_NAMES = ['Seasonal Highlights', 'Trending Now'] as const;

/**
 * 共通体験カード上に表示するテーマタグの最大件数。
 */
export const EXPERIENCE_CARD_THEME_TAG_MAX_DISPLAY = 3;
